import { APP_BACKGROUND_COLOR, APP_COLOR, APP_HOVER_COLOR, BORDER_COLOR, FONT_FAMILY, SKIP_BUTTON_BACKGROUND_COLOR, SKIP_BUTTON_TEXT_COLOR, TEXT_COLOR } from "../../theme";

export const styles = {
    rightSideContainer: {
        margin: "0px 15px 0px 15px",
        width: "100%",
        overflowY: "scroll",
        scrollbarWidth: "none",
        paddingLeft: "15px",
        paddingRight: "15px",
        height: "calc(100vh)",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    } as const,
    projectsHeaderContainer: {
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: APP_BACKGROUND_COLOR,
        padding: "5px 0 20px"
    } as const,
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: '40vh',
        width: "100%"
    } as const,
    headerContainer: {
        marginTop: "15px",
        display: "flex",
        justifyContent: "space-between",
    } as const,

    filterButton: {
        borderRadius: "var(--radius-md, 8px)",
        height: "55px",
        color: TEXT_COLOR,
        fontWeight: "bold",
        border: `1px solid ${BORDER_COLOR}`,
        background:
            "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        textTransform: "none",
        fontSize: "14px",
        paddingRight: "20px",
        "&:hover": {
            boxShadow:
                "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
        },
    } as const,
    emptyMessageContainer: {
        display: "flex",
        justifyContent: "center",
        height: "20vh",
        border: `1px solid ${BORDER_COLOR}`,
        alignItems: "center",
    } as const
};

export const projectFilterMenuStyles = {
    menuBox: {
        minWidth: "300px",
        padding: "15px",
        backgroundColor: APP_BACKGROUND_COLOR,
    } as const,
};


export const profilePageStyles = {
    addItemButton: {
        display: "inline-block",
        cursor: "pointer",
        backgroundColor: APP_COLOR,
        color: "black",
        borderRadius: "5px",
        fontSize: "16px",
        fontWeight: "bold",
        border: "none",
        textTransform: "none",
        height: "40px",
        "&:hover": {
            backgroundColor: APP_HOVER_COLOR,
        },
    } as const,
    skipButton: {
        borderRadius: "var(--radius-md, 8px)",
        border:
            "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
        background: SKIP_BUTTON_BACKGROUND_COLOR,
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        color: SKIP_BUTTON_TEXT_COLOR,
        textTransform: "none",
    } as const,
}

export const projectPageStyles = {
    filesSectionContainer: {
        borderRadius: "var(--radius-xl, 12px)",
        overflowY: "scroll",
        minWidth: "1100px",
        scrollbarWidth: "none",
        border: `1px solid ${BORDER_COLOR}`,
        "&::-webkit-scrollbar": {
            display: "none",
        },
    } as const,
    filterContainer: {
        display: "flex",
        marginTop: "10px",
        marginBottom: "10px",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap"
    } as const,
    filterContainerBox: {
        height: "100%",
        marginTop: "10px",
    } as const,
    filesScrollContainer: {
        maxWidth: "100vw",
        overflow: "scroll",
        scrollbarWidth: "none",
        height: "calc(100vh - 210px)",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    } as const,
    filesMainContainer: {
        border: `1px solid ${BORDER_COLOR}`,
        borderRadius: "var(--radius-xl, 12px)",
        height: "calc(100vh - 150px)",
    } as const,
    titlesContainer: {
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        gap: "auto",
        backgroundColor: "#1F242F",
        borderTopLeftRadius: "var(--radius-xl, 12px)",
        borderTopRightRadius: "var(--radius-xl, 12px)",
        position: "sticky",
        top: "0",
        zIndex: 1000,
        border: `1px solid ${BORDER_COLOR}`
    } as const,
    arrowIcon: {
        color: APP_COLOR,
        fontSize: "22px"
    } as const,
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "20vh",
        width: "100%",
    } as const,
    emptyMessageContainer: {
        display: "flex",
        justifyContent: "center",
        height: "20vh",
        border: `1px solid ${BORDER_COLOR}`,
        alignItems: "center",
    } as const,
    breadcrumbsLinks: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "&:hover": {
            color: APP_COLOR,
        },
        cursor: 'pointer'
    } as const,
    deleteRemoveButton: {
        borderRadius: "var(--radius-md, 8px)",
        textTransform: "none",
        color: "black",
        "&:hover": {
            backgroundColor: APP_HOVER_COLOR,
        },
        "&:disabled": {
            backgroundColor: 'grey',
        },
        backgroundColor: APP_COLOR,
        fontFamily: FONT_FAMILY,
        fontWeight: "bold",
        paddingX: 2,
        fontSize: "14px",
        height: "37px",
        padding: "10px",
    } as const,
} 